import { motion } from "framer-motion";
import { REQUEST_EXAMPLES } from "../../data/content";
import { ChapterLabel, Container, FadeUp, EASE } from "./ui";

const list = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

const item = {
  hidden: { opacity: 0, y: 26 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

const RequestTypes = () => (
  <section className="border-t border-line bg-ink py-28 md:py-40" data-testid="request-types-section">
    <Container>
      <ChapterLabel num="11" label="What Can We Find ?" />

      <motion.div
        variants={list}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        className="mt-16 max-w-[820px] md:mt-20"
      >
        {REQUEST_EXAMPLES.map((q, i) => (
          <motion.p
            key={q}
            variants={item}
            className="group cursor-default border-b border-line/60 py-5 font-serif text-xl font-medium italic text-neutral-500 transition-colors duration-500 hover:text-ivory md:py-6 md:text-[26px]"
            data-testid={`request-example-${i + 1}`}
          >
            {q}
          </motion.p>
        ))}
      </motion.div>

      <FadeUp delay={0.2} y={40} duration={0.9} className="mt-16 md:mt-24">
        <p
          className="font-serif font-medium leading-none text-ivory text-[clamp(80px,14vw,200px)]"
          data-testid="request-types-oui"
        >
          OUI<span className="text-champagne">.</span>
        </p>
      </FadeUp>
    </Container>
  </section>
);

export default RequestTypes;
